import React from 'react'
import classNames from 'classnames'
import { CGE } from '..'
import Autocomplete from 'react-autocomplete'
import InputMask from "react-input-mask";
import AlertModal from "../../AlertModal";
import ReCAPTCHA from "react-google-recaptcha-enterprise";

const FieldRecaptcha = ({ onChange, sitekey, horizontal, style, captchaRef }) => {
  return (
    <div className={classNames(
      'cge-form-element mb-4',
      {
        'cge-form-element--horizontal': horizontal
      }

    )}>
      <div className="cge-form-element__label">
        <CGE.Text
          htmlFor="recaptchaId"
          text="Validación de seguridad:"
          size="4"
          mandatoryElement={true}
          style={style}
        />
      </div>
      <div>
      <ReCAPTCHA
          id={"recaptchaId"}
          ref={captchaRef}
          language="es"
          sitekey={sitekey}
          onChange={onChange}
          hl="es-419"
        />
        <CGE.Text
          className="text-danger mb-3 font-weight-bold"
          htmlFor="recaptchaId"
          text="Por motivos de seguridad necesitamos validar que no eres un Robot"
          size="2"
          mandatoryElement={true}
        />
      </div>
    </div>
  )
}

const FieldCheckPassowd = ({checked = false, labelName}) => {
  return (
    <div className="cge-form-element">
      <div className={classNames(
        'cge-form-element__check mb-2',
        {
          'cge-form-element__check-success': checked
        }

      )}>
        <p>{checked ? "✓" : "✖"} {labelName}</p>

      </div>
    </div>

  )
}

const CheckBoxGroup = ({ labelNameCheckBoxGroup, mandatoryElement, horizontal,
  optionsGroup, hasError, msgError }) => {

  return (
    <div
      className={classNames(
        'cge-form-element'
      )}>
      <div className="cge-form-element__label">
        {labelNameCheckBoxGroup &&
          <CGE.Text
            text={labelNameCheckBoxGroup}
            size="4"
            mandatoryElement={mandatoryElement}
          />}
        {optionsGroup && (
          <div
            className={classNames(
              {
                'cge-form-element__checkbox--horizontal': horizontal,
              }
            )}
          >
            {optionsGroup?.map(obj => {
              return (
                <CGE.FormsField
                  className={obj.className}
                  checked={obj?.checked}
                  horizontal={obj?.horizontal}
                  labelName={obj?.labelName}
                  handleChange={obj?.handleChange}
                  idFormElement={obj?.idFormElement}
                  typeFormElement={obj?.typeFormElement}
                  mandatoryElement={obj?.mandatoryElement}
                  typeElement={obj?.typeElement}
                  value={obj?.value}
                  
                />
              )

            })}
            {hasError &&
              <div>
                <CGE.Text infoLabel={true} size="2" className="text-danger font-weight-bold" text={msgError} />
                <CGE.Spacing type="md" />
              </div>
            }
          </div>
        )}

      </div>
    </div>
  )
}

const FormsField = ({ labelName, handleChange, idFormElement, typeFormElement, mandatoryElement, typeElement, listOptions, horizontal,
  hasError, msgError, placeholder, value, disabled, readOnly, successMode, className, autocomplete, atcGetItemValue, atcItems,
  atcMenuStyle, atcOnChange, atcOnSelect, atcRef, atcRenderItem, atcShouldItemRender, atcValue, atcWrapperStyle, style, maxLength,
  numberOfColumns, numberOfRows, checked, beforeMaskedValueChange, mask, formatChars, propsLabelInfoContent, inputExemple, onInput,
  minLenght, textAfterMandatory, labelStyle, labelClass, accept, min, horizontalAutocomplete, infoLabelMsg, selected, inputProps}) => {

    let classAux = "mb-4";
    if(className === "mb-0") {
      classAux = className;
    }
    
  return (
    <div
      className={classNames(
        classAux,'cge-form-element',
        {
          'cge-form-element--horizontal': horizontal,
        }
      )}>
      {typeFormElement !== ("checkbox" || "radio") && <div className={classNames(
        'cge-form-element__label', labelClass,
        {
          'cge-form-element__label horizontal-autocomplete': horizontalAutocomplete,
          'd-flex': propsLabelInfoContent,
        }
      )}>
        <CGE.Text
          className={classNames(
            {
              'input-autocomplete': horizontalAutocomplete,
            }
          )}
          htmlFor={idFormElement}
          text={labelName}
          size="4"
          mandatoryElement={mandatoryElement === true ? <b class="text-danger">*</b> : ''}
          textAfterMandatory={textAfterMandatory}
          style={labelStyle}
          horizontal={horizontal}
        />
        {propsLabelInfoContent &&
          <a
            onClick={() => propsLabelInfoContent?.setVisibleModal(true)}
            className="ml-2 cge-form-element__label-icon"
            title={propsLabelInfoContent?.titleHint?propsLabelInfoContent?.titleHint:""}
          >
            <p className="">?</p>
          </a>}
        {propsLabelInfoContent?.visibleModal && (
          <AlertModal
            titleModal={propsLabelInfoContent?.titleModal}
            observer={propsLabelInfoContent?.observer}
            onClose={propsLabelInfoContent?.onClose}
            status={propsLabelInfoContent?.status}
          >
            <div dangerouslySetInnerHTML={{
              __html: propsLabelInfoContent?.content,
            }}
            ></div>
          </AlertModal>
        )}

        {autocomplete ?
          // to use the autocomplete={true} prop in the forms component it is necessary to fill in the autocomplete component props below!!
          <div 
          className={classNames(
            {
              'cge-form-element__autoComplete--hasError': hasError,
            }
          )}
          style={!horizontalAutocomplete ? { position: 'relative' } : { position: 'relative', flexGrow: '1' }}>
            <Autocomplete
              getItemValue={atcGetItemValue}
              items={atcItems}
              menuStyle={atcMenuStyle}
              onChange={atcOnChange}
              onSelect={atcOnSelect}
              ref={atcRef}
              renderItem={atcRenderItem}
              shouldItemRender={atcShouldItemRender}
              value={atcValue}
              wrapperStyle={atcWrapperStyle}
              placeholder={placeholder}
              inputProps={inputProps}
            />
            {hasError &&
              <div>
                <i className="cge-form-element__autoComplete-icon">
                  <CGE.Icon
                    name="attention"
                    style={{ fontSize: '23px', color: '#f32735' }}
                  />
                </i>
                <CGE.Text className="text-danger font-weight-bold" size="2" text={msgError} />
              </div>
            }
          </div>
          : ''
        }
      </div>}
      <div className={classNames(
        {
          'cge-form-element__input-group': typeFormElement !==  ("checkbox" || "radio"),
        }
      )}>
        {typeElement === "input" &&
          <>
            <div className='d-flex'>
              <input
                value={value}
                disabled={disabled}
                className={classNames(
                  className,
                  {
                    'cge-form-element__input': typeFormElement !==  ("checkbox" || "radio"),
                    'cge-form-element__input--hasError': hasError,
                    'cge-form-element__input--success': value && !hasError && successMode,
                    'cge-form-element__input--filled': value && !hasError,
                  }
                )}
                type={typeFormElement}
                id={idFormElement}
                placeholder={!disabled && placeholder}
                onChange={(e) => handleChange(e)}
                readOnly={readOnly}
                style={style}
                maxLength={maxLength}
                minLength={minLenght}
                checked={checked}
                onInput={onInput}
                accept={accept}
                min={min}
                ref={atcRef}
              />
              {typeFormElement ===  ("checkbox" || "radio") &&
                <div className="cge-form-element-input-checkbox__label">
                  <CGE.Text
                    htmlFor={idFormElement}
                    text={labelName}
                    size="4"
                    mandatoryElement={mandatoryElement ? <b class="text-danger">*</b> : ''}
                    horizontal={horizontal}
                    typeFormElement={typeFormElement}
                  />
                </div>
              }
            </div>
           
            {hasError &&
              <div>
                <i className="cge-form-element__input-icon">
                  <CGE.Icon
                    name="attention"
                    style={{ fontSize: '23px', color: '#f32735' }}
                  />
                </i>
                <CGE.Text className="text-danger font-weight-bold" size="2" text={msgError} />
              </div>
            }
             {infoLabelMsg && 
            <CGE.Text size="2" text={infoLabelMsg}/>}
        
            {inputExemple &&
              <div className="cge-form-element__input-inputExemple">
                <CGE.Text size="2" text={inputExemple} />

              </div>
            }

            {value && !hasError && successMode &&
              <i className="cge-form-element__input-icon">
                <CGE.Icon
                  name="check"
                  style={{ fontSize: '23px', color: '#00b451' }}
                />
              </i>}
          </>
        }

        {typeElement === "select" &&
          <>
            <select
              className={classNames(
                'cge-form-element__input', className,
                {
                  'cge-form-element__input--hasError': hasError,
                  'cge-form-element__input--success': value && !hasError && successMode,
                  'cge-form-element__input--filled': value && !hasError,
                }
              )}
              disabled={disabled}
              type={typeFormElement}
              id={idFormElement}
              onChange={(e) => handleChange(e)}
              onClick={(e) => handleChange(e)}
              style={style}
              readonly={readOnly}
              ref={atcRef}
            >
              {listOptions?.map((item) => (
                <option
                  key={item.value}
                  label={item.label}
                  value={item.value}
                  selected={ selected ? selected : item.value === value}
                >{item.label}</option>
              ))}
            </select>

            {hasError &&
              <CGE.Text className="text-danger font-weight-bold" size="2" text={msgError} />
            }
          </>
        }

        {typeElement === "textarea" &&
          <>
            <textarea
              className={classNames(
                'cge-form-element__text-area', className,
                {
                  'cge-form-element__input--hasError': hasError,
                  'cge-form-element__input--success': value && !hasError && successMode,
                  'cge-form-element__input--filled': value && !hasError,
                }
              )}
              cols={numberOfColumns}
              disabled={disabled}
              id={idFormElement}
              maxLength={maxLength}
              onChange={(e) => handleChange(e)}
              placeholder={!disabled && placeholder}
              rows={numberOfRows}
              style={style}
              value={value}
            />

            {hasError &&
              <div>
                <i className="cge-form-element__input-icon">
                  <CGE.Icon
                    name="attention"
                    style={{ fontSize: '23px', color: '#f32735' }}
                  />
                </i>
                <CGE.Text className="text-danger font-weight-bold" size="2" text={msgError} />
              </div>
            }
          </>
        }
        {typeElement === "input-mask" &&
          <>
            <div className='d-flex'>

              <InputMask
                value={value}
                placeholder={!disabled && placeholder}
                className={classNames(
                  className,
                  {
                    'cge-form-element__input': typeFormElement !==  ("checkbox" || "radio"),
                    'cge-form-element__input--hasError': hasError,
                    'cge-form-element__input--success': value && !hasError && successMode,
                    'cge-form-element__input--filled': value && !hasError,
                  }
                )}
                style={style}
                name={idFormElement}
                type="text"
                onChange={(e) => handleChange(e)}
                formatChars={formatChars}
                mask={mask}
                maskChar={null}
                readOnly={readOnly}
                beforeMaskedValueChange={beforeMaskedValueChange}
                disabled={disabled}
              />
            </div>

            {hasError &&
              <div>
                <i className="cge-form-element__input-icon">
                  <CGE.Icon
                    name="attention"
                    style={{ fontSize: '23px', color: '#f32735' }}
                  />
                </i>
                <CGE.Text className="text-danger font-weight-bold" size="2" text={msgError} />
              </div>
            }

            {infoLabelMsg && 
            <CGE.Text size="2" text={infoLabelMsg}/>}
        
            {inputExemple &&
              <div className="cge-form-element__input-inputExemple">
                <CGE.Text size="2" text={inputExemple} />

              </div>
            }

            {value && !hasError && successMode &&
              <i className="cge-form-element__input-icon">
                <CGE.Icon
                  name="check"
                  style={{ fontSize: '23px', color: '#00b451' }}
                />
              </i>}
          </>
        }
      </div>
    </div >
  )
}

export { FormsField as default, CheckBoxGroup, FieldRecaptcha, FieldCheckPassowd };
